export default __webpack_public_path__ + "static/logo-hero-46403fe68e4ca0b001a9ac791a127a3c.svg";